function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 25,
  cy: 25,
  r: 25,
  fill: "#2156E7"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M34.8098 16.8521C33.1779 15.0877 31.0538 13.8539 28.7127 13.3106C26.3715 12.7673 23.9211 12.9395 21.679 13.805C19.4368 14.6704 17.5062 16.1891 16.1372 18.1645C14.7681 20.1398 14.0238 22.4808 14.0006 24.884C13.9773 27.2873 14.6763 29.6422 16.0069 31.6436C17.3375 33.645 19.2384 35.2008 21.4634 36.1094C23.6884 37.018 26.135 37.2376 28.4862 36.7396C30.8375 36.2417 32.985 35.0492 34.6507 33.3166L30.6681 29.4879C29.7693 30.4228 28.6104 31.0663 27.3416 31.335C26.0728 31.6037 24.7526 31.4853 23.5519 30.995C22.3512 30.5046 21.3255 29.6651 20.6074 28.5851C19.8894 27.505 19.5122 26.2343 19.5248 24.9374C19.5373 23.6405 19.939 22.3773 20.6777 21.3114C21.4165 20.2454 22.4583 19.4259 23.6683 18.9588C24.8782 18.4918 26.2005 18.3989 27.4638 18.6921C28.7272 18.9853 29.8734 19.6511 30.754 20.6032L34.8098 16.8521Z",
  fill: "white"
});

var SvgSourceCoinbase = function SvgSourceCoinbase(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSourceCoinbase, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/source_coinbase.4ac44236.svg";
export { ForwardRef as ReactComponent };